import { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";

// Gestion de cajeros (alta, edicion, reset de password, activar/desactivar).
// Solo lo usa el modulo de Usuarios, visible unicamente para rol Administrador.
const useUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [planteles, setPlanteles] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);

  const obtenerUsuarios = useCallback(async () => {
    setCargando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosObtenerUsuarios.php`);
      const data = await res.json();
      if (data.success) {
        setUsuarios(data.usuarios || []);
        setRoles(data.roles || []);
        setPlanteles(data.planteles || []);
      } else {
        Swal.fire("Error", data.message || "No se pudo cargar la lista de cajeros.", "error");
      }
    } catch (error) {
      Swal.fire("Error de conexión", "No se pudo conectar con el servidor.", "error");
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    obtenerUsuarios();
  }, [obtenerUsuarios]);

  const crearUsuario = async (datos) => {
    setGuardando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosCrearUsuario.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos)
      });
      const data = await res.json();
      if (data.success) {
        Swal.fire("Listo", data.message, "success");
        await obtenerUsuarios();
        return true;
      }
      Swal.fire("No se pudo crear", data.message || "Error desconocido.", "error");
      return false;
    } catch (error) {
      Swal.fire("Error de conexión", "No se pudo conectar con el servidor.", "error");
      return false;
    } finally {
      setGuardando(false);
    }
  };

  const actualizarUsuario = async (datos) => {
    setGuardando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosActualizarUsuario.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos)
      });
      const data = await res.json();
      if (data.success) {
        Swal.fire("Listo", data.message, "success");
        await obtenerUsuarios();
        return true;
      }
      Swal.fire("No se pudo actualizar", data.message || "Error desconocido.", "error");
      return false;
    } catch (error) {
      Swal.fire("Error de conexión", "No se pudo conectar con el servidor.", "error");
      return false;
    } finally {
      setGuardando(false);
    }
  };

  const cambiarPassword = async (id, passwordNuevo) => {
    setGuardando(true);
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosCambiarPasswordUsuario.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, passwordNuevo })
      });
      const data = await res.json();
      Swal.fire(data.success ? "Listo" : "No se pudo cambiar", data.message, data.success ? "success" : "error");
      return data.success;
    } catch (error) {
      Swal.fire("Error de conexión", "No se pudo conectar con el servidor.", "error");
      return false;
    } finally {
      setGuardando(false);
    }
  };

  const cambiarEstatus = async (id, estatus) => {
    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosCambiarEstatusUsuario.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, estatus })
      });
      const data = await res.json();
      if (data.success) {
        await obtenerUsuarios();
      } else {
        Swal.fire("No se pudo cambiar el estatus", data.message || "Error desconocido.", "error");
      }
      return data.success;
    } catch (error) {
      Swal.fire("Error de conexión", "No se pudo conectar con el servidor.", "error");
      return false;
    }
  };

  return {
    usuarios,
    roles,
    planteles,
    cargando,
    guardando,
    crearUsuario,
    actualizarUsuario,
    cambiarPassword,
    cambiarEstatus
  };
};

export default useUsuarios;
